import Create from './container';

export const route = {
  path: '/witchcraft/tables/create',
  name: 'Tables Witch',
  component: Create,
};
